import { Alert, AlertTitle, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Stack, TextField, Tooltip } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useImperativeHandle } from "react";
import { forwardRef } from "react";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import CustomDatePicker from "../utilities/CustomDatePicker";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useTheme } from "styled-components";

const VoucherForm = forwardRef((props, ref) => {
    const [vouchertype, setVoucherType] = useState();
    const [vouchertypeDesc, setVoucherTypeDesc] = useState();
    const [refType, setRefType] = useState('NO_REFERENCE');
    const [docDate, setdocDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [refDocType, setRefDocType] = useState();
    const [checkPosting, setCheckPosting] = useState();
    const [refDocNo, setRefDocNo] = useState();
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [voucherTypeOptions, setVoucherTypeOptions] = useState([]);
    const navigate = useNavigate();
    const voucherTypeUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherTypes}`;
    const financeYearUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.financeYear}`;

    const handleDateChange = async(value) => {
        setdocDate(moment(value).format('YYYY-MM-DD'))
    }

    const handleChangeVT = (event) => {
        setVoucherType(event.id)
        setRefDocType(event.value)
        setVoucherTypeDesc(event.desc)
    }

    const handleRefChange = (e) => {
        if (e.target.value === 'WITH_REFERENCE' || e.target.value === 'REVERSE_REFERENCE') {
            setdocDate(props.selectrowPros[0].docDate);
            setVoucherType(props.selectrowPros[0].voucherTypeId)
            setRefDocType(props.selectrowPros[0].voucherTypeShortKey)
        }
        setRefType(e.target.value)
    }

    const handleSubmit = () => {
        navigate('/addVoucher', { state: { docDate: docDate, vouchertype: vouchertype, refType: refType, refDocNo: refDocNo, voucherTypeDesc: vouchertypeDesc } })
    }

    useEffect(() => {
        if (docDate && vouchertype && refType && checkPosting) {
            setSaveDisabled(false);
        } else {
            setSaveDisabled(true)
        }
    }, [docDate, vouchertype, refType,checkPosting])

    useEffect(() => {
        props.checkSaveDisabled(saveDisabled)
    }, [saveDisabled])

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit
    }))

    useEffect(() => {
        const voucherTypes = async () => {
            const types = await OAuthService.getList(voucherTypeUrl);
            const vouchers = types?.data?._embedded?.voucherTypes?.map((type) => {
                return { label: type.shortKey + ' ' + type.description,desc: type.description, value: type.shortKey, id: type?._links?.self?.href.split('/').pop() }
            });
            if (vouchers && vouchers.length > 0) {
                setVoucherTypeOptions(vouchers)
            }
        };

        voucherTypes();
        if (props.selectrowPros && props.selectrowPros.length > 0 && props.selectrowPros.filter((value) => value.docRef !== null).length > 0) {
            setRefDocNo(props.selectrowPros[0].docRef)
        }

        postingCheck()
    }, []);
    const postingCheck = async() => {
        const checkPostingDate = await OAuthService.getList(financeYearUrl+`/checkPostingAvailability?checkDate=${docDate}`);
        setCheckPosting(checkPostingDate?.data?.isPostingAllowed);
    }
    
    useEffect(() => {
        postingCheck()
    },[docDate])

    return (
        <div>
            {checkPosting === false && <Alert severity="error" className="mb-16">
                    <AlertTitle>Error</AlertTitle>
                    {`Voucher posting for Doc. Date '${moment(docDate).format('DD-MM-YYYY')}' is not allowed as financial year for desire period is not defined into the system`}
                </Alert>}
            {((props.selectrowPros && props.selectrowPros.length > 0 && props.selectrowPros.filter((value) => value.docRef !== null)).length > 0 && props.selectrowPros[0].status !== 'APPROVED') && <Alert severity="error" className="mb-16">
                    <AlertTitle>Error</AlertTitle>
                    {`Creation of 'With Reference' & 'Reverse Reference' voucher is only allowed for Approved vouchers`}
                </Alert>}
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <div className="flex mb-10">
                        <label className="pt-6 grow basis-0 float-left">Voucher Type:</label>
                        <FormControl size="small" className=" grow basis-0">
                            <Select
                                name="vouchertype"
                                value={(vouchertype && voucherTypeOptions.length > 0) && voucherTypeOptions.filter((list) => list.id.toString() === vouchertype.toString())}
                                onChange={handleChangeVT}
                                isDisabled={refType === 'NO_REFERENCE' ? false : true}
                                options={voucherTypeOptions}
                                styles={{
                                    ...customStyles('', '', '0px'),
                                    option: (provided, { data, isDisabled, isFocused, isSelected }) => {
                                        const theme = useTheme();
                                        return {
                                            ...provided,
                                            backgroundColor: isFocused ? isDisabled ? "#000" : "gray" : theme?.palette?.mode === 'dark' ? "#000" : 'default',
                                            color: isDisabled ? '#7e7979' : "primary",
                                            fontSize: '13px'
                                        }
                                    },
                                }}
                            >
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex mt-10">
                        <label className="pt-6 grow basis-0 float-left">Doc Date:</label>
                        <Stack className="float-right grow basis-0">
                            <CustomDatePicker
                                // className="float-right"
                                format={'dd-MM-yyyy'}
                                name={'docdate'}
                                value={docDate}
                                disabled={refType === 'NO_REFERENCE' ? false : true}
                                handleChange={handleDateChange}
                                renderInput={(params) => <TextField size="small" InputLabelProps={{
                                }} {...params} sx={{
                                    backgroundColor: props.viewData && '#8080800f'
                                }} />}
                            />
                        </Stack>
                    </div>

                    <div className="flex">
                        <FormControl variant="standard">
                            <label>Create:</label>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={refType === 'NO_REFERENCE'} onChange={handleRefChange} name="noRef" value={'NO_REFERENCE'} />
                                    }
                                    sx={{ml: '-3px'}}
                                    label="No Reference"
                                />

                                {(props.selectrowPros && props.selectrowPros.length > 0 && props.selectrowPros.filter((value) => value.docRef !== null)).length > 0 &&
                                    // {(props.selectrowPros && props.selectrowPros.length > 0 && props.voucherNumber.voucherNo) &&
                                    <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={refType === 'WITH_REFERENCE'} disabled={props.selectrowPros[0].status === 'APPROVED' ? false :true} onChange={handleRefChange} name="withRef" value={'WITH_REFERENCE'} />
                                            }
                                            label="With Reference"
                                            sx={{ml: '-3px'}}
                                            disabled={props.selectrowPros[0].status === 'APPROVED' ? false :true} 
                                        />
                                        {props.selectrowPros[0].voucherReference !== 'REVERSE_REFERENCE' && <FormControlLabel
                                            control={
                                                <Checkbox checked={refType === 'REVERSE_REFERENCE'} disabled={props.selectrowPros[0].status === 'APPROVED' ? false :true} onChange={handleRefChange} name="reverseRef" value={'REVERSE_REFERENCE'} />
                                            }
                                            label="Reverse Reference"
                                            sx={{ml: '-3px'}}
                                            disabled={props.selectrowPros[0].status === 'APPROVED' ? false :true} 
                                        />}
                                    </>
                                }
                            </FormGroup>
                        </FormControl>
                    </div>

                    {(refType === 'WITH_REFERENCE' || refType === 'REVERSE_REFERENCE') && <div className="mt-8"  >
                        <label>Reference Doc</label>
                        <div className="flex">
                            <TextField
                                name='vouchertype'
                                value={refDocType}
                                size="small"
                                className="w-[35%] "
                                InputProps={{
                                    readOnly: true,
                                    sx: {
                                        borderRadius: 0
                                    },
                                }}
                            />
                            <TextField
                                name='refDocNo'
                                size="small"
                                className="w-[45%]"
                                value={props.selectrowPros[0].voucherNo}
                                InputProps={{
                                    readOnly: true,
                                    sx: {
                                        borderRadius: 0
                                    },
                                }}
                            />
                        </div>
                    </div>}
                </Grid>
                {/* <Grid item xs={5} className="relative">
                    <><div className="flex mb-10 mx-5">
                        <FormControl variant="standard">
                            <label>Create:</label>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={refType === 'NO_REFERENCE'} onChange={handleRefChange} name="noRef" value={'NO_REFERENCE'} />
                                    }
                                    label="No Reference"
                                />

                                {(props.selectrowPros && props.selectrowPros.length > 0 && props.selectrowPros.filter((value) => value.docRef !== null)).length > 0 &&
                                    // {(props.selectrowPros && props.selectrowPros.length > 0 && props.voucherNumber.voucherNo) &&
                                    <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={refType === 'WITH_REFERENCE'} onChange={handleRefChange} name="withRef" value={'WITH_REFERENCE'} />
                                            }
                                            label="With Reference"
                                        />
                                        {props.selectrowPros[0].voucherReference !==  'REVERSE_REFERENCE' &&<FormControlLabel
                                            control={
                                                <Checkbox checked={refType === 'REVERSE_REFERENCE'} onChange={handleRefChange} name="reverseRef" value={'REVERSE_REFERENCE'} />
                                            }
                                            label="Reverse Reference"
                                        />}
                                    </>
                                }
                            </FormGroup>
                        </FormControl>
                    </div>
                    </>
                </Grid> */}
            </Grid>
        </div>
    )
});

export default VoucherForm;
